export default [
	{
		name: "superuserDashboard",
		path: "",
		component: () => import("../pages/dashboard.vue"),
	},
];
